import React, { forwardRef } from 'react';
import { GridContainer, CenterContent } from 'global/components/perform-grid';
import Table from './table';

export default forwardRef((props, ref) => {
  return (
    <GridContainer>
      <CenterContent fullWidth>
        <Table {...props} ref={ref} />
      </CenterContent>
    </GridContainer>
  );
});
